/* eslint-disable jsx-a11y/anchor-is-valid */
import {process, State} from "@progress/kendo-data-query"
import {Grid, GridCellProps, GridColumn, GridColumnMenuCheckboxFilter} from "@progress/kendo-react-grid"
import {Tooltip} from "@progress/kendo-react-tooltip"
import {useEffect, useState} from "react"
import {BookingReminder, setSelectedBookingId, toggleTestDialog} from "../../containers/MotBooking/bookingSlice"
import {RootState} from "../../rootReducer"
import {columnProps} from "../../shared/ActiveGridFilter"
import {SpinnerGrid} from "../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../store"
import BookingReminderActivity from "./BookingReminderActivity"

function BookingReminderGrid() {
    const dispatch = useAppDispatch()
    const bookingReminders = useAppSelector((state: RootState) => state.containers.motBooking.bookingReminder)
    const loading = useAppSelector((state: RootState) => state.containers.motBooking.bookingReminderLoading)
    const initialState: State = {skip: 0, take: 100}
    const [dataState, setDataState] = useState<State>(initialState)
    useEffect(() => {
        setDataState(initialState)
    }, [bookingReminders])

    const openEditBookingDialog = (e: any, props: any) => {
        e.preventDefault()
        dispatch(setSelectedBookingId(props.dataItem.bookingID))
        props.dataItem.bookingTypeID === 1 && dispatch(toggleTestDialog(true))
    }

    const setBookingRegLinkColor = (dataItem: BookingReminder) => {
        if (dataItem.bookingTypeID === 1 && dataItem.internal) {
            return "#447F83"
        }
        return "#D65549"
    }

    const AddLinkCell = (props: any) => (
        <td style={{left: "0px", color: setBookingRegLinkColor(props.dataItem)}} className="k-grid-content-sticky">
            <a
                style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                }}
                onClick={event => openEditBookingDialog(event, props)}
            >
                {props.dataItem.bookingRef}
            </a>
        </td>
    )
    const CustomColumnCell = (props: GridCellProps) => (
        <td
            style={props.style}
            className={`${props.className}`}
            colSpan={props.colSpan}
            role={"gridcell"}
            title={props.dataItem[`${props.field}`]}
        >
            {props.dataItem[`${props.field}`]}
        </td>
    )

    const ActiveColumnCell = (props: GridCellProps) => {
        const {dataItem} = props
        const data = dataItem
        return (
            <td
                style={props.style}
                className={`${props.className}`}
                colSpan={props.colSpan}
                role={"gridcell"}
                title={props.dataItem[`${props.field}`]}
            >
                {props.dataItem[`${props.field}`]}
                {!data.noEmailAddress ? (
                    <BookingReminderActivity
                        bookingId={data.bookingID}
                        isEmailEmpty={data.isEmailEmpty}
                    />
                ) : (
                    ""
                )}
            </td>
        )
    }

    return (
        <div className="position-relative">
            {loading && <SpinnerGrid />}
            <Tooltip openDelay={100} position="bottom" anchorElement="pointer">
                <Grid
                    style={{height: "calc(100vh - 15.6rem)"}}
                    data={process(bookingReminders, dataState)}
                    {...dataState}
                    pageable
                    sortable
                    onDataStateChange={event => setDataState(event.dataState)}
                >
                    <GridColumn
                        {...columnProps("bookingRef", dataState)}
                        field="bookingRef"
                        title="Booking"
                        locked
                        cell={props => <AddLinkCell {...props} />}
                        width={140}
                    />
                    <GridColumn
                        {...columnProps("testStart", dataState)}
                        field="testStart"
                        title="Test Date"
                        filter={"date"}
                        format="{0:d}"
                        width={110}
                    />
                    <GridColumn field="timing" title="Time" filterable={false} width={120} />
                    <GridColumn
                        {...columnProps("customerName", dataState)}
                        field="customerName"
                        title="Customer Name"
                        width={170}
                        cell={CustomColumnCell}
                    />
                    <GridColumn
                        {...columnProps("reminderCall", dataState)}
                        columnMenu={props => <GridColumnMenuCheckboxFilter {...props} data={bookingReminders} expanded={true} />}
                        field="reminderCall"
                        title="Reminder Call"
                        width={160}
                        cell={CustomColumnCell}
                    />
                    <GridColumn
                        {...columnProps("reminderEmail", dataState)}
                        field="reminderEmail"
                        title="Reminder Email"
                        columnMenu={props => <GridColumnMenuCheckboxFilter {...props} data={bookingReminders} expanded={true} />}
                        cell={CustomColumnCell}
                        width={170}
                    />
                    <GridColumn
                        {...columnProps("confirmationEmail", dataState)}
                        field="confirmationEmail"
                        title="Confirmation"
                        cell={CustomColumnCell}
                        columnMenu={props => <GridColumnMenuCheckboxFilter {...props} data={bookingReminders} expanded={true} />}
                        width={170}
                    />
                    <GridColumn
                        field=""
                        title=""
                        cell={ActiveColumnCell}
                        width={60}
                    />
                </Grid>
            </Tooltip>
        </div>
    )
}

export default BookingReminderGrid
